import React from 'react'
import { Component } from 'react'
import { Home } from '../Projects/Home';
import './index.css'

import {getMe} from '../../Me'
const me = getMe();

export class Project extends Component {
    constructor (props) {
        super(props);
        this.state = {
            project: 'HOME'
        }
    }

    renderNewProject = (projectname) => {
        let projElement
        let fadeIn ='nanoFadeIn';

      switch (projectname) {
            default:
            case 'HOME':
                projElement = <Home navClick={this.changeProject} fade={fadeIn} nano={me.nanoHome} />;
                break;
            case 'TETE':
                projElement = <Home fade={fadeIn} nano={me.nanoTete} />;
                break;
            case 'FD':
                projElement = <Home fade={fadeIn} nano={me.nanoFastDetect} />;
                break;
            case 'IAR':
                projElement = <Home fade={fadeIn} nano={me.nanoIllusionsAR} />;
                break;
            case 'LB' :
                projElement = <Home fade={fadeIn} nano={me.nanoLetsBuild} />;
                break
            case 'P2R' :
                projElement = <Home fade={fadeIn} nano={me.nanoPlanToRelax} />;
                break;
        }
        
        return(projElement);
    }

    changeProject = (projectname) => {
        this.setState({project: projectname});
    }

    render() {
        return(
            <div>
                {this.renderNewProject(this.state.project)}
            </div>
        );
    }

    componentDidMount() {
    }

    componentWillUnmount () {
        // dom node deleted
    }

    componentDidUpdate(previousProps, previousState) {
        
    }
}
